import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import NeubauProjekteImageVideo from "./NeubauProjekteImageVideo";
import ImageTitleTextButton from "../modules/ImageTitleTextButton";
import TitleTextButton from "../modules/TitleTextButton";
import QuoteModule from "../modules/QuoteModule";
import LocalMapComponent from "./LocalMapComponent";

function NeubauProjekteDetailTabs({ allData, locationData, formButtons }) {
    const [activeTab, setActiveTab] = useState("");

    useEffect(() => {
        if (allData?.length > 0) {
            setActiveTab(allData[0]?.Tab_Titel);
        }

        console.log('here data >>>>>>>>>>>>>>', allData)
    }, [allData]);

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".tab-content .col-inner h4"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });
        };



        // run on load
        setTimeout(equalHeight, 300);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    useEffect(() => {
        console.log("all data", allData)
    }, [])

    const currentTabData = allData?.find(
        (item) => item.Tab_Titel === activeTab
    );

    const imgArr = ["/images/blue-icon-3.svg", "/images/Wohnungen.svg", "/images/blue-icon-1.svg", "/images/Gewerbe.svg"]

    return (
        <div>
            <div className="tab_wrapper">
                <div className='container'>
                    {/* Nav Tabs */}
                    <ul className="nav nav-tabs">
                        {allData?.map((tab, index) => (

                            <li className="nav-item" key={index}>

                                <button
                                    className={`nav-link ${activeTab === tab?.Tab_Titel ? "active" : ""
                                        }`}
                                    onClick={() => setActiveTab(tab?.Tab_Titel)}
                                >
                                    {tab?.Tab_Titel}
                                </button>

                            </li>

                        ))}
                    </ul>
                </div>

                {/* Tab Content */}
                <div className="tab-content mt-4">
                    <>
                        {currentTabData?.neubauprojekte_registerkarten_daten?.Modul?.map((module, index) => (
                            <div key={index}>
                                {module.__component === "modules.short-titel-titel-text-button" &&
                                    <section className={`pt-pb-10 sec-blue-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                        <div className='container'>
                                            <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                        </div>
                                    </section>
                                }
                                {module.__component === "modules.carousel-bild-re-text" &&
                                    <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="blue" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                                }
                                {module.__component === "modules.quote" &&
                                    <section className={`pt-pb-10 sec-blue-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                        <div className='container'>
                                            <QuoteModule data={module?.Quote} titleColor="blue" />
                                        </div>
                                    </section>
                                }
                                {/* {module.__component === "modules.link-facts-module" &&
                                    <section className='pt-pb-10 sec-new-zahlen sec-blue-color'>
                                        <div className='container'>
                                            <div className='row'>
                                                {module?.Link_Facts?.map((item, index) => (
                                                    <div key={index} className='col-sm-6 col-lg-4 mb-4 mb-lg-0'>
                                                        <Link to={item?.Link} className='col_inner'>
                                                            <div className='icon-icon'>
                                                                <img src={`https://backend.bgzurlinden.ch${item?.Icon?.url}`} />
                                                            </div>
                                                            <div className='text-button'>
                                                                <h3 className='fs_30 mb-2'>{item?.Titel}</h3>
                                                                <p>{item?.Text}</p>
                                                                <span className='btn-circle'>
                                                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M24.2676 18.0508C24.2512 18.754 23.6678 19.3374 22.9646 19.3538C22.2614 19.3702 21.7046 18.8134 21.721 18.1102L22.0835 2.57667L6.54995 2.93916C5.84672 2.95557 5.28993 2.39878 5.30635 1.69556C5.32277 0.992338 5.90615 0.408938 6.60937 0.392528L23.4162 0.000367795C24.1194 -0.0160363 24.6762 0.540743 24.6598 1.24397L24.2676 18.0508Z" fill="white" />
                                                                        <path d="M2.15282 24.2661C1.64395 24.7749 0.837738 24.7937 0.352084 24.3081C-0.133571 23.8224 -0.114755 23.0162 0.394106 22.5073L22.5071 0.394318C23.016 -0.114544 23.8222 -0.133357 24.3079 0.352297C24.7935 0.837952 24.7747 1.64417 24.2658 2.15303L2.15282 24.2661Z" fill="white" />
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </section>} */}
                                {module.__component === "modules.benefits" &&
                                    <section className='pt-pb-10 sec-bg-grey sec-pink-color'>
                                        <div className='container'>
                                            <div className='row default-grid-gap job-card-row tabs-content'>
                                                {module?.Benefits_Data?.map((item, index) => (
                                                    <div key={index} className='col-6 col-md-4 col-lg-3 col-item mt-4'>
                                                        <div className="col-inner position-relative">
                                                            <img src={`https://backend.bgzurlinden.ch${item.Icon?.url}`} alt={item?.Titel} className="item-icon" />
                                                            <h4 lang="de" className='text-darkgrey fw-550 fs_24'>{item?.Titel}</h4>
                                                            <p lang="de">{item?.Text}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </section>
                                }


                            </div>
                        ))}
                        {activeTab?.toLowerCase() === "fakten" &&
                            // <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                            //     {/* <div className='container'> */}
                            //     <div className='zah_fakten_map'>
                            //         <LocalMapComponent locationData={locationData} localAddress={true} markerColor="blue" />
                            //     </div>
                            //     {/* </div> */}
                            // </section>

                            <section className="new-blue-fakten pt-pb-10">
                                <div className="container">
                                    <div className="row">
                                        {locationData?.map((item, index) => (
                                            <div key={index} className="col-lg-8 align-self-center">
                                                <div className="sec-title">
                                                    <h2 className="fs-50">{item?.Page_Titel}</h2>
                                                    {item?.Standort?.Text?.split("\n").map((line, index) => (
                                                        <span key={index}>
                                                            {line}
                                                            <br />
                                                        </span>
                                                    ))}
                                                </div>
                                                <div className="row">
                                                    {item?.Standort?.Titel_Text?.map((i, ind) => (
                                                        <div key={ind} className="col-6 col-md-3 col-item mt-4">
                                                            <div className="col-inner">
                                                                <img src={imgArr[ind]} />
                                                                <h2 className="fs-30 mt-0">{i?.Titel}</h2>
                                                                {/* <p>{i?.Text}</p> */}
                                                                <p>
                                                                    {i?.Text?.split("\n").map((line, index) => (
                                                                        <span key={index}>
                                                                            {line}
                                                                            <br />
                                                                        </span>
                                                                    ))}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                        <div className="col-lg-4 mt-lg-0 mt-4">
                                            <div className="blue_map">
                                                {/* <img src="/images/map-blue.png" className="w-100" /> */}
                                                <LocalMapComponent locationData={locationData} localAddress={true} markerColor="blue" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        }
                        {activeTab?.toLowerCase() === "projektidee" &&
                            <section className='pt-pb-10 sec-new-zahlen sec-blue-color'>
                                <div className='container'>
                                    <div className='row'>
                                        {formButtons?.map((item, index) => (
                                            <div key={index} className='col-sm-6 col-lg-4 mb-4 mb-lg-0'>
                                                <Link to={item?.Link} className='col_inner'>
                                                    <div className='icon-icon'>
                                                        <img src={`https://backend.bgzurlinden.ch${item?.blue_Icon?.url}`} />
                                                    </div>
                                                    <div className='text-button'>
                                                        <h3 className='fs_30 mb-2'>{item?.Titel}</h3>
                                                        <p>{item?.Text}</p>
                                                        <span className='btn-circle'>
                                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M24.2676 18.0508C24.2512 18.754 23.6678 19.3374 22.9646 19.3538C22.2614 19.3702 21.7046 18.8134 21.721 18.1102L22.0835 2.57667L6.54995 2.93916C5.84672 2.95557 5.28993 2.39878 5.30635 1.69556C5.32277 0.992338 5.90615 0.408938 6.60937 0.392528L23.4162 0.000367795C24.1194 -0.0160363 24.6762 0.540743 24.6598 1.24397L24.2676 18.0508Z" fill="white" />
                                                                <path d="M2.15282 24.2661C1.64395 24.7749 0.837738 24.7937 0.352084 24.3081C-0.133571 23.8224 -0.114755 23.0162 0.394106 22.5073L22.5071 0.394318C23.016 -0.114544 23.8222 -0.133357 24.3079 0.352297C24.7935 0.837952 24.7747 1.64417 24.2658 2.15303L2.15282 24.2661Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </section>
                        }
                    </>
                </div>
            </div>
            {/* <section className="new-blue-fakten pt-pb-10">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 align-self-center">
                            <div className="sec-title">
                                <h2 className="fs-50">Aenean sollicitudin</h2>
                                <p>Albisriederstrasse 350-358<br />Bachwiesenstrasse 143+145 Wydlerweg 2-<br />12 8047 Zürich</p>
                            </div>
                            <div className="row">
                                <div className="col-6 col-md-3 col-item mt-4">
                                    <div className="col-inner">
                                        <img src="/images/blue-icon-3.svg" />
                                        <h2 className="fs-30 mt-0">Baujahr</h2>
                                        <p>Areal A: 2015 <br />Areal B: 2013</p>
                                    </div>
                                </div>
                                <div className="col-6 col-md-3 col-item mt-4">
                                    <div className="col-inner">
                                        <img src="/images/blue-icon-4.svg" />
                                        <h2 className="fs-30 mt-0">Wohnungen</h2>
                                        <p>Areal A: 78 <br />Areal B: 140</p>
                                    </div>
                                </div>
                                <div className="col-6 col-md-3 col-item mt-4">
                                    <div className="col-inner">
                                        <img src="/images/blue-icon-1.svg" />
                                        <h2 className="fs-30 mt-0">Häuser</h2>
                                        <p>3</p>
                                    </div>
                                </div>
                                <div className="col-6 col-md-3 col-item mt-4">
                                    <div className="col-inner">
                                        <img src="/images/blue-icon-2.svg" />
                                        <h2 className="fs-30 mt-0">Gewerbe</h2>
                                        <p>3</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mt-lg-0 mt-4">
                            <div className="blue_map">
                                <img src="/images/map-blue.png" className="w-100" />
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
        </div>
    );
}

export default NeubauProjekteDetailTabs;